<app-base-modal
  [open]="open"
  (openChange)="openChange.emit($event)"
  title="Create Project"
  [size]="'lg'"
>
  <form id="projectForm" class="space-y-4" (ngSubmit)="submit()" [formGroup]="projectForm">
    <div>
      <label class="block text-sm font-bold text-gray-700 mb-1">Group</label>
      <select
        formControlName="groupId"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <option value="">Select a group</option>
        @for (group of groups; track group.id) {
          <option [value]="group.id">{{ group.name }}</option>
        }
      </select>
      @if (submitted && projectForm.controls.groupId.errors?.required) {
        <small class="text-sm text-red-600">Group is required.</small>
      }
    </div>

    <div>
      <label class="block text-sm font-bold text-gray-700 mb-1">Project Title</label>
      <input
        type="text"
        formControlName="title"
        placeholder="Enter project title"
        maxlength="255"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary"
      />
      @if (submitted && projectForm.controls.title.errors?.required) {
        <small class="text-sm text-red-600">Title is required.</small>
      }
      @if (submitted && projectForm.controls.title.errors?.maxlength) {
        <small class="text-sm text-red-600">Title must be at most 255 characters long.</small>
      }
    </div>

    <div>
      <label class="block text-sm font-bold text-gray-700 mb-1">Description</label>
      <textarea
        formControlName="description"
        rows="3"
        maxlength="1000"
        class="w-full px-3 py-2 h-32 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary h-36"
      ></textarea>
      @if (submitted && projectForm.controls.description.errors?.maxlength) {
        <small class="text-sm text-red-600"
          >Description must be at most 1000 characters long.</small
        >
      }
    </div>

    @if (error) {
      <app-base-alert
        type="error"
        title="Error creating project"
        [message]="error.detail"
        (closed)="error = ''"
      ></app-base-alert>
    }

    <div data-modal-footer class="flex justify-end gap-2">
      <button
        type="button"
        class="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md transition-colors"
        (click)="close()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="px-4 py-2 bg-secondary hover:bg-hover text-white rounded-md transition-colors"
      >
        Create
      </button>
    </div>
  </form>
</app-base-modal>
